<div class="flex min-h-screen">
  @if (!isIframe) {
    <div
      class="flex flex-shrink-0 relative ease-in-out duration-300"
      [ngClass]="collapseService.collapsed() ? 'w-24' : 'w-80'"
    >
      <app-navigation></app-navigation>
    </div>
  }
  <div class="w-full flex-grow h-screen overflow-y-auto overflow-x-hidden ease-in-out duration-300">
    <app-version-update-banner></app-version-update-banner>
    <div class="sticky top-0 z-50">
      <app-alert-service-wrapper area="global"></app-alert-service-wrapper>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>

<app-hotkey-index></app-hotkey-index>
